import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchStaffAdvanceApi,
  addStaffAdvanceApi,
  updateStaffAdvanceApi,
  deleteStaffAdvanceApi,
} from "../services/StaffAdvanceService";

export const fetchStaffAdvance = createAsyncThunk(
  "StaffAdvance/fetch",
  async ({ id, fromDate, toDate }) =>
    fetchStaffAdvanceApi(id, fromDate, toDate),
);
export const addStaffAdvance = createAsyncThunk(
  "StaffAdvance/add",
  async (data) => addStaffAdvanceApi(data),
);
// Ensure update passes the ID
export const updateStaffAdvance = createAsyncThunk(
  "StaffAdvance/update",
  async (data) => updateStaffAdvanceApi(data),
);
export const deleteStaffAdvance = createAsyncThunk(
  "StaffAdvance/delete",
  async (id) => {
    await deleteStaffAdvanceApi(id);
    return id;
  },
);

const StaffAdvanceSlice = createSlice({
  name: "StaffAdvance",
  initialState: { advances: [], status: "idle" },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaffAdvance.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchStaffAdvance.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.advances = action.payload;
      })
      .addCase(fetchStaffAdvance.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(deleteStaffAdvance.fulfilled, (state, action) => {
        state.advances = state.advances.filter((a) => a.id !== action.payload);
      });
  },
});
export default StaffAdvanceSlice.reducer;
